
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns32b5b005082d315a2bf555ff4eb7fba2en from './en.yaml'
            i18n.addResourceBundle('en', '32b5b005082d315a2bf555ff4eb7fba2', flattenObject(ns32b5b005082d315a2bf555ff4eb7fba2en), true, true);
        
        export default '32b5b005082d315a2bf555ff4eb7fba2';
    